
import { Component, Prop, Vue } from 'vue-property-decorator'
import TitlePage from '@/components/atoms/TitlePage.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import ButtonLogin from '@/components/molecules/ButtonLogin.vue'
import InputText from '@/components/molecules/InputText.vue'

/**
 * メールアドレス登録ページのフォーマット
 */
@Component({
  components: {
    TitlePage,
    LabelBase,
    PanelFrame,
    ButtonLogin,
    InputText,
  },
})
export default class RegistMailAddress extends Vue {
  /** メールアドレス登録処理 */
  @Prop()
  eventSubmit!: (mailAddress: string) => Promise<void>

  /** 入力メールアドレス */
  private mailAddress = ''

  /**
   * 入力チェック
   *
   * @returns メールアドレスが正しく入力済みでない場合はtrueを返す
   */
  private get isButtonDisabled(): boolean {
    return this.mailAddress === ''
  }

  /**
   * 登録ボタンクリック時処理
   */
  private async submitMailAddress(): Promise<void> {
    await this.eventSubmit(this.mailAddress)
  }
}
